import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';

const AppUrlListener: React.FC<any> = () => {
  const history = useHistory();

  useEffect(() => {
    let listenerHandle: PluginListenerHandle | undefined;

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      console.log('[Deeplink]', event.url);

      if (/reset-password/i.test(event.url)) {
        return;
      }

      let slug = '';
      if (event.url.indexOf('.com') !== -1) {
        slug = event.url.split('.com').pop() || '';
      } else {
        slug = event.url.split('.app').pop() || '';
      }

      if (slug) {
        history.push(slug);
      }
    }).then(handle => {
      listenerHandle = handle;
    });

    return () => {
      void listenerHandle?.remove();
    };
  }, [history]);

  return null;
};

export default AppUrlListener;
